import actions from './actions'
import getters from './getters'
import types from './types'

const state = {
  title: ''
}

const mutations = {
  [types.TITLE.SET](state, title) {
    state.title = title
  },
  [types.TITLE.DELETE](state) {
    state.title = ''
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
